module.exports = __webpack_public_path__ + "static/media/user.951af062.svg";